export default function recommendationUniqueNameDirective(
  $q,
  $timeout,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    $timeout(
      () => {
        const recommendationCategoryId = attributes.recommendationCategoryId || -1;
        const recommendationId = attributes.recommendationId || -1;

        const cache = {};
        ngModel.$asyncValidators.amRecommendationUniqueName = (modelValue) => {
          if (modelValue && cache[modelValue] !== true) {
            return amSharedModelService
              .checkRecommendationNameExists(recommendationCategoryId, recommendationId, modelValue)
              .then((nameExists) => {
                if (!nameExists) {
                  cache[modelValue] = true;
                  return $q.resolve();
                }
                cache[modelValue] = false;
                return $q.reject();
              })
              .catch(() => {
                cache[modelValue] = false;
                $q.reject();
              });
          }
          return $q.resolve();
        };
      },
      0
    );
  }
}

export const name = 'amRecommendationUniqueName';

recommendationUniqueNameDirective.$inject = [
  '$q',
  '$timeout',
  'amSharedModelService'
];
